<template>
    <b-button
        variant="primary"
        @click.stop="confirmarSalvar()"
        :disabled="!aplicacao.valida"
        class="mr-2"
    >
        <span> <i class="fa fa-floppy-o"></i> Salsasvar</span>
    </b-button>
</template>

<script>
import AplicacoesServicos from './AplicacoesServicos'

export default {
    props: {
        acao: {
            type: String
        },

        aplicacao: {
            type: Object
        }
    },

    methods: {
        confirmarSalvar() {
            this.$swal({
                title: `${
                    this.acao == 'I' ? 'Inserir' : 'Atualizar'
                } Aplicação`,
                html: `Confirma a ${
                    this.acao == 'I' ? 'inserção' : 'atualização'
                } da aplicação <b>${this.aplicacao.codigo}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$emit('atualizarErros', [])
            this.$store.dispatch('addRequest')
            let promisse
            if (this.acao == 'I') {
                promisse = AplicacoesServicos.inserir(this.aplicacao)
            } else if (this.acao == 'A') {
                promisse = AplicacoesServicos.atualizar(this.aplicacao)
            }
            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            `Aplicação ${
                                this.acao == 'I' ? 'inserida' : 'atualizada'
                            } com sucesso`,
                            'OK',
                            this.$toastConfig.success
                        )
                        this.$emit('atualizarAplicacao', response.data)
                        this.$router.push({
                            name: 'Aplicacoes_Detalhar',
                            params: { aplicacaoId: response.data.aplicacaoId }
                        })
                        this.$store.dispatch('setRecarregar', true)
                    } else {
                        this.$emit('atualizarErros', response.errors)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>
